import './index.css'

const Footer = () => (
  <footer className="footer">
    <h1 className="footer-title">Footer</h1>
  </footer>
)

export default Footer
